import { render, staticRenderFns } from "./EmrVitalsignDetail.vue?vue&type=template&id=c57a4c28&scoped=true"
import script from "./EmrVitalsignDetail.vue?vue&type=script&lang=js"
export * from "./EmrVitalsignDetail.vue?vue&type=script&lang=js"
import style0 from "./EmrVitalsignDetail.vue?vue&type=style&index=0&id=c57a4c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57a4c28",
  null
  
)

export default component.exports